<!--
 * @Author: Yishiyao
 * @Date: 2020.3.4
 * @LastEditors  : Yishiyao
 * @Description: 获取协议
 * @Remarks:
 -->
<template>
  <div class="treaty-dl">
    <el-dialog
      ref="treatyDialog"
      width="550px"
      @opened="getAgreement"
      :visible.sync="agShow"
      :before-close="handleClose">
      <div slot="title" class="ag-hd">
        {{ agree.name }}
      </div>
      <div class="treaty-txt" v-html="agree.detail">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api/api'
import { Loading } from 'element-ui'
export default {
  props: ['cateId', 'agShow'],
  data () {
    return {
      agree: {
        loading: {},
        name: '',
        detail: ''
      } // 协议
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {

  },
  methods: {
    async getAgreement () {
      this.loading = Loading.service({
        target: '.treaty-dl'
      })
      const agRes = await API.getAgreement({
        cateId: this.cateId
      })
      this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
        this.loading.close()
      })
      if (agRes.data.statusCode === '200') {
        this.agree = agRes.data.result
      } else {
        this.$message({
          message: agRes.data.message,
          type: 'error'
        })
      }
    },
    handleClose () {
      this.$emit('agrShowHandler', false)
    }
  },
  components: {

  }
}
</script>

<style lang="stylus">
.itreaty-dl
  width 100%
.treaty-txt
  width 100%
  height 400px
  overflow-y scroll
.ag-hd
  color #31a826
  font-size 20px
  padding-bottom 0px
  .el-dialog__body
      padding 10px 20px
      font-size 20px
    .el-dialog__footer
      padding-top 0px
    .login-tabs
      center()
      .or-tab
        width 85%
        .wrapper
          width 90%
          margin 15px auto
          &.b-wrapper
            center()
            margin-top 30px
        .login-btn
          width 100%
      .qr-wrapper
        height 200px
        center()
    .tp-lg-dialog-footer
      width 85%
      margin 0 auto
      padding-top 0
      flex-ltr-parent()
      color #999999
      font-size 14px
</style>
